import React, {forwardRef, useImperativeHandle, useRef} from "react";
import CompanyListType from "./subPages/CompanyListType";
import CompanyCreateForm from "./subPages/CompanyCreateForm";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getCompanyList} from "../../../api/company/CompanyService";
import "./companyManagePanel.css";

const CompanyManagePanel = forwardRef(function CompanyManagePanel(
    {viewMode = "list", onViewModeChange},
    ref,
) {
    const createFormRef = useRef(null);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    };

    const {newData, pageInfo, dataHook} = useRequestData(getCompanyList, initDate, "company");

    useImperativeHandle(ref, () => ({
        submitCreate: () => createFormRef.current?.submit(),
    }), []);

    if (viewMode === "create") {
        return (
            <CompanyCreateForm
                ref={createFormRef}
                embedded
                hideActions
                onCancel={() => onViewModeChange?.("list")}
                onSuccess={() => {
                    onViewModeChange?.("list");
                    dataHook.refresh();
                }}
            />
        );
    }

    return (
        <CompanyListType
            data={newData.content}
            pageInfo={pageInfo}
            dataHook={dataHook}
        />
    );
});

export default CompanyManagePanel;
